// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"bacb411d","839":"1fcf5f82"}[chunkId] + ".chunk.js";
};